import createBreakpoint from 'shared-tokens/utils/breakpoints';

import { mainCls as cardCls } from '../../style';

const brTablet = createBreakpoint('s');
const brDesk = createBreakpoint('m');
const brLarge = createBreakpoint('l');

export const mainCls =  `${cardCls}__plhlder`;

export default {
  [mainCls]: {
    height: 275,
    [brTablet]: {
      height: 'auto !important',
      width: 388,
    },
    [brDesk]: {
      width: 328,
    },
    [brLarge]: {
      width: 388,
    },    
    '&.medium': {
      height: 242,
      [brTablet]: {
        width: 328,
      },
      [brDesk]: {
        width: 305,
      },
      [brLarge]: {
        width: 328,
      },
    },    
    '&.small': {
      height: 222,
      [brTablet]: {
        width: 288,
      },
      [brDesk]: {
        width: 271,
      },
      [brLarge]: {
        width: 288,
      },
    },
  },
  [`${mainCls}__wrap`]: {
    height: '100%',
    [brTablet]: {
      background: '#D7DBDF !important',
      paddingTop: '75%',
    },

  },
  [`${mainCls}__imgcont`]: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    '& img': {      
      width: 'auto',
      height: 'auto',
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
      objectPosition: 'center center',
    },
  }
};
